import React from 'react';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Fab from '@material-ui/core/Fab';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  secondary: {
    background: '#822823',
    '&:hover': {
      background: '#57221e'
    }
  }
});

class AdminDeleteButton extends React.Component {
  render() {
    return (
      <Fab
        color="secondary"
        aria-label="Purge"
        style={{position: 'absolute', right: 20, bottom: 20, zIndex: 1000}}
        {...this.props}
      >
        <DeleteForeverIcon />
      </Fab>
    );
  }
}

export default withStyles(styles)(AdminDeleteButton);
